import { render } from "./BizIcon.vue?vue&type=template&id=2d510ac3&ts=true"
import script from "./BizIcon.vue?vue&type=script&lang=ts"
export * from "./BizIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__